<template>
  	<FlexAddPinBatch />
</template>

<script>

// @ is an alias to /src
import FlexAddPinBatch from "@/components/Flex/AddPinBatch.vue";

export default {
  name: "FlexAddPinBatchs",
  components: {
    FlexAddPinBatch,
  },
};
</script>
